import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { getAuth } from "firebase/auth";
import { useModal } from "../../context/ModalContext";
import { useRouter } from "next/router";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { useAuth } from "../../context/AuthProvider";
import { Delete } from "react-iconly";
import { useQueryClient } from "react-query";
import { Button, SecondaryButton } from "@jammable/ui-core";
import { Spinner } from "@jammable/ui-components/Loader";

// ...

const DeleteCommentModal = ({ comment, sortBy }) => {
  const [loading, setLoading] = useState(false);
  const { closeModal } = useModal();
  const [error, setError] = useState(null);
  const queryClient = useQueryClient();

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <div className="tw-text-xl tw-font-black">Delete Comment</div>
      {error && <div className="error-message">{error}</div>}
      <div className="tw-mb-1 tw-leading-6">
        Are you sure you want to delete your comment? This is not reversible.
      </div>
      <div className="tw-flex tw-gap-2">
        <SecondaryButton
          onClick={() => {
            closeModal("delete-comment-modal");
          }}
          type="submit"
          className="tw-w-full tw-h-11 tw-rounded-full"
        >
          Cancel
        </SecondaryButton>
        <Button
          onClick={async () => {
            const auth = getAuth();
            const token = await auth?.currentUser?.getIdToken();
            setLoading(true);
            axios
              .delete(`/api/comment/deleteComment`, {
                headers: { Authorization: token },
                params: {
                  commentId: comment._id,
                },
              })
              .then(async () => {
                await queryClient.invalidateQueries([
                  "comments",
                  comment.modelId,
                ]);

                toast.success("Comment deleted successfully!");
                setTimeout(() => {
                  setLoading(false);
                }, 1500);
                closeModal("delete-comment-modal");
              })
              .catch((err) => {
                if (err?.response?.data?.message) {
                  setError(err.response.data.message);
                }
                setLoading(false);
              });
          }}
          type="submit"
          className="tw-w-full tw-bg-red-500 tw-border-none hover:tw-bg-red-600 tw-h-11 tw-rounded-full"
        >
          {loading ? (
            <Spinner size={4} className="tw-border-white tw-border-3" />
          ) : (
            "Delete Comment"
          )}
        </Button>
      </div>
    </div>
  );
};

export default DeleteCommentModal;
